var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
var CustomTooltipTop = function (_a) {
    var children = _a.children, tooltipContent = _a.tooltipContent;
    var _b = __read(useState(false), 2), visible = _b[0], setVisible = _b[1];
    return (React.createElement("div", { className: "primary-custom-tooltip-container", onMouseEnter: function () { return setVisible(true); }, onMouseLeave: function () { return setVisible(false); } },
        children,
        React.createElement("div", { className: "tooltip-wrapper ".concat(visible ? "visible" : "") },
            tooltipContent,
            React.createElement("div", { className: "tooltip-notch" }))));
};
export default CustomTooltipTop;
